import gql from 'graphql-tag';

export const mutationUpdateDokkioItem = gql`
  mutation updateDokkioItem (
    $id: DokkioID!
    $description: String
    $logoID: DokkioID
    $dokkioTagIDs: [DokkioID!]
  ) {
    updateDokkioItem (
      id: $id
      description: $description
      logoID: $logoID
      dokkioTagIDs: $dokkioTagIDs
    ) {
      dokkioClass
      id
    }
  }
`;
export default mutationUpdateDokkioItem;
